import SheetMenu from './SheetMenu';
import UserAvatar from '@/components/general/UserAvatar';
import SidebarToggle from './_components/SidebarToggle';

export default function Navbar() {
    return (
        <header className='sticky z-20 top-0 w-full bg-background-3 shadow backdrop-blur dark:shadow-secondary'>
            <div className='mx-4 sm:mx-8 flex h-16 items-center'>
                <div className='flex items-center space-x-4 lg:space-x-0'>
                    <SheetMenu />
                    <SidebarToggle />
                </div>
                <div className='flex flex-1 items-center space-x-2 justify-end'>
                    <UserAvatar />
                </div>
            </div>
        </header>
    );
}
